import { createAction } from 'redux-act';
import {
    IAddNewCard,
    ICreatePaymentIntent,
    IGetPublishableKey,
    IGetPublishableKeyResponse,
    IPaymentIntentResponse,
    types,
} from './types';
import { IPaymentCard } from '../../types/global/generic.types';
import { IErrorType } from '../../constants/types';
import { IGenericDocumentModifier } from '../../types/global/helper';

export const addPaymentMethod = createAction<IAddNewCard>(types.ADD_PAYMENT_METHOD);
export const addPaymentMethodSuccess = createAction<IPaymentCard>(types.ADD_PAYMENT_METHOD_SUCCESS);
export const addPaymentMethodFail = createAction<IErrorType>(types.ADD_PAYMENT_METHOD_FAIL);

export const updatePaymentMethod = createAction<IGenericDocumentModifier>(types.UPDATE_PAYMENT_METHOD);
export const updatePaymentMethodSuccess = createAction<IPaymentCard>(types.UPDATE_PAYMENT_METHOD_SUCCESS);
export const updatePaymentMethodFail = createAction<IErrorType>(types.UPDATE_PAYMENT_METHOD_FAIL);

export const deletePaymentMethod = createAction<IGenericDocumentModifier>(types.DELETE_PAYMENT_METHOD);
export const deletePaymentMethodSuccess = createAction<IGenericDocumentModifier>(types.DELETE_PAYMENT_METHOD_SUCCESS);
export const deletePaymentMethodFail = createAction<IErrorType>(types.DELETE_PAYMENT_METHOD_FAIL);

export const getPaymentMethods = createAction(types.GET_PAYMENT_METHODS);
export const getPaymentMethodsSuccess = createAction<IPaymentCard[]>(types.GET_PAYMENT_METHODS_SUCCESS);
export const getPaymentMethodsFail = createAction<IErrorType>(types.GET_PAYMENT_METHODS_FAIL);

export const createPaymentIntent = createAction<ICreatePaymentIntent>(types.CREATE_PAYMENT_INTENT);
export const createPaymentIntentSuccess = createAction<IPaymentIntentResponse>(types.CREATE_PAYMENT_INTENT_SUCCESS);
export const createPaymentIntentFail = createAction<IErrorType>(types.CREATE_PAYMENT_INTENT_FAIL);

export const createPaymentIntentForPurchase = createAction<ICreatePaymentIntent>(
    types.CREATE_PAYMENT_INTENT_FOR_PURCHASE,
);
export const createPaymentIntentForPurchaseSuccess = createAction<IPaymentIntentResponse>(
    types.CREATE_PAYMENT_INTENT_FOR_PURCHASE_SUCCESS,
);
export const createPaymentIntentForPurchasetFail = createAction<IErrorType>(
    types.CREATE_PAYMENT_INTENT_FOR_PURCHASE_FAIL,
);

export const getPublishableKey = createAction<IGetPublishableKey>(types.GET_PUBLISHABLE_KEY);
export const getPublishableKeySuccess = createAction<IGetPublishableKeyResponse>(types.GET_PUBLISHABLE_KEY_SUCCESS);
export const getPublishableKeyFail = createAction<IErrorType>(types.GET_PUBLISHABLE_KEY_FAIL);
